import { type Collections } from '@air/api';
import { type ShortUrlResponse } from '@air/api/types';
import { type ApiResponse } from '@air/utils-api';

const DEFAULT_SHOWCASE_TITLE = 'Showcase';

type CollectionGetResponse = ApiResponse<typeof Collections.get>;

/** Public copy/open actions only when an existing link is enabled (same gate as ShowcaseEditor). */
const getViewableShowcaseShareShortId = (shortUrl: ShortUrlResponse | null): string | null => {
  if (!shortUrl || shortUrl.disabled) {
    return null;
  }

  return shortUrl.id;
};

export type WorkspaceAgentShowcaseMonikerSubject = {
  collectionId: string;
  /** Public short id when an existing share link is viewable; absent when only in-product actions apply. */
  shareShortId: string | null;
  /**
   * Preview still. Always null for now — `Collections.get` has no thumbnail; `/showcases` list stills come from
   * `Workspaces.ShortUrl.list`. Design/product follow-up for preview parity.
   */
  thumbnailUrl: string | null;
  title: string;
};

export const toWorkspaceAgentShowcaseMonikerSubject = (
  collection: CollectionGetResponse,
  shortUrl: ShortUrlResponse | null,
): WorkspaceAgentShowcaseMonikerSubject => ({
  collectionId: collection.id,
  shareShortId: getViewableShowcaseShareShortId(shortUrl),
  thumbnailUrl: null,
  title: collection.name || DEFAULT_SHOWCASE_TITLE,
});
